import type { DrawerKey, DrawerPayloads } from './drawer.type'

type OpenHandler = <K extends DrawerKey>(
  key: K,
  payload: DrawerPayloads[K],
) => void

let openHandlerRef: OpenHandler | undefined

export function setDrawerOpenHandler(handler: OpenHandler | undefined) {
  openHandlerRef = handler
}

export function openDrawer<K extends DrawerKey>(
  key: K,
  payload: DrawerPayloads[K],
): boolean {
  if (!openHandlerRef) {
    if (process.env.NODE_ENV !== 'production') {
      // no-op if provider not mounted
      console.warn('No open handler found for drawer registry')
    }
    return false
  }

  openHandlerRef(key, payload)
  return true
}
